import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import CaricaAnnuncio from './routes/caricaAnnuncio'
import ModificaAnnuncio from './routes/modificaAnnuncio'
import ModificaDraft from './routes/modificaDraft'
import {
  CARICA_ROUTE,
  MODIFICA_DRAFT_ROUTE,
  MODIFICA_ROUTE,
  CARICA_ROUTE_NEW,
  MODIFICA_DRAFT_ROUTE_NEW,
  MODIFICA_ROUTE_NEW
} from './assets/routes'
import { StepProvider } from './utils/StepContext'

const Routes = (props) => {
  return (
    <Switch>
      <StepProvider>
        <Route exact path={CARICA_ROUTE}>
          <CaricaAnnuncio {...props} />
        </Route>
        <Route exact path={MODIFICA_DRAFT_ROUTE}>
          <ModificaDraft {...props} />
        </Route>
        <Route exact path={MODIFICA_ROUTE}>
          <ModificaAnnuncio {...props} />
        </Route>

        <Route exact path={CARICA_ROUTE_NEW}>
          <CaricaAnnuncio {...props} />
        </Route>
        <Route exact path={MODIFICA_DRAFT_ROUTE_NEW}>
          <ModificaDraft {...props} />
        </Route>
        <Route exact path={MODIFICA_ROUTE_NEW}>
          <ModificaAnnuncio {...props} />
        </Route>
      </StepProvider>
    </Switch>
  )
}

export default withRouter(Routes)
